import React from "react";
import { FolderKanban, PenTool, Mail, Users, TrendingUp, HardDrive } from "lucide-react";
import { useFeatureFlags } from "../lib/feature_flags";

// iter-114 / iter-132: Plugins button was moved into the user dropdown
// (Admin control panel); a new "Files" button replaces it here so users
// can jump straight into the file manager.
const FLAG_BY_KEY = {
    projects: "show_bottom_projects",
    contacts: "show_bottom_contacts",
    leads: "show_bottom_leads",
    template: "show_bottom_templates",
    email: "show_bottom_email",
    files: "show_bottom_files",
};

export const BottomToolbar = ({
    onProjects,
    onBuildTemplate,
    onEmail,
    onContacts,
    onLeads,
    onFiles,
}) => {
    const flags = useFeatureFlags();
    const buttons = [
        { key: "projects", label: "Projects", icon: FolderKanban, onClick: onProjects, testid: "toolbar-btn-projects" },
        { key: "contacts", label: "Contacts", icon: Users, onClick: onContacts, testid: "toolbar-btn-contacts" },
        { key: "leads", label: "Leads", icon: TrendingUp, onClick: onLeads, testid: "toolbar-btn-leads" },
        { key: "template", label: "Templates", icon: PenTool, onClick: onBuildTemplate, testid: "toolbar-btn-template" },
        { key: "email", label: "Email", icon: Mail, onClick: onEmail, testid: "toolbar-btn-email" },
        { key: "files", label: "Files", icon: HardDrive, onClick: onFiles, testid: "toolbar-btn-files" },
    ]
        .filter((b) => typeof b.onClick === "function")
        .filter((b) => flags[FLAG_BY_KEY[b.key]] !== false);

    if (buttons.length === 0) return null;

    return (
        <div
            className="fixed bottom-0 left-0 right-0 z-40 pb-[env(safe-area-inset-bottom)] md:bottom-6 md:pb-0 md:left-1/2 md:right-auto md:-translate-x-1/2 md:w-auto"
            data-testid="bottom-toolbar"
        >
            <div className="flex items-stretch md:items-center gap-1 md:gap-2 p-2 md:p-2 bg-[#1C253C]/95 backdrop-blur-xl border-t md:border border-[#2A3655] md:rounded-full shadow-[0_4px_28px_rgba(0,0,0,0.6)] overflow-x-auto md:overflow-visible">
                {buttons.map(({ key, label, icon: Icon, onClick, testid }) => (
                    <button
                        key={key}
                        onClick={onClick}
                        data-testid={testid}
                        className="shrink-0 flex-1 md:flex-none flex flex-col md:flex-row items-center justify-center gap-1 md:gap-2 px-3 md:px-4 py-2.5 md:py-2.5 text-[10px] md:text-sm font-medium text-slate-200 hover:text-white hover:bg-[#2A3655] rounded-md md:rounded-full transition-colors active:scale-95"
                    >
                        <Icon className="w-5 h-5 md:w-4 md:h-4 text-[#00A3FF]" />
                        <span>{label}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default BottomToolbar;
